import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export default function useMutateCandidate() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: (candidate) => {
      return axios.patch(`/candidate/${candidate.uuid}`, candidate);
    },
    onSuccess: (data, variables) => {
      client.setQueryData(["candidateDetails", variables.uuid], data);
    },
  });
}
